exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gh-home-video[data-v-1422f942]{height:100%}.gh-home-video .gh-video[data-v-1422f942]{position:fixed;top:50%;left:50%;min-width:100%;min-height:100%;width:auto;height:auto;transform:translateX(-50%) translateY(-50%);background:#000;transition:opacity 1s}.gh-home-video .gh-home-mobile-video[data-v-1422f942]{height:100vh;background:url(/images/Style1-Women-bw@2x.jpg) no-repeat top/cover}", ""]);

// exports
